const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/downloads.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
type ReleaseAsset = {
  id: number;
  name: string;
  download_url: string;
  size: number;
};
type AssetInfo = {
  platform: "Windows" | "macOS" | "Linux" | "Other";
  variant: string;
  icon: React.ReactNode;
  description: string;
};
type VariantGroup = {
  variant: string;
  description: string;
  assets: ReleaseAsset[];
};
type PlatformGroup = {
  platform: "Windows" | "macOS" | "Linux" | "Other";
  icon: React.ReactNode;
  variants: Record<string, VariantGroup>;
};
export const Route = createFileRoute("/{-$locale}/downloads")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});